import { TextField } from '@mui/material';
import { isNil } from 'es-toolkit';

import { useModifiedStyleForWeb } from '@savvy/deprecated-shared/theme';
import { mapIconNameToIconComponent } from '@savvy/deprecated-shared/x-icons/utils';

import type { KeyValue, XTextFieldProps } from './types';
import { mapKeyboardTypeToInputMode } from './utils';

export function XTextField({
  // Consumed/mapped below — must not reach the DOM <input>.
  style: styleProp,
  inputStyle: inputStyleProp,
  keyboardType,
  rightIcon,
  rightIconProps,
  onChangeText,
  onKeyPress,
  maxLength,
  // React Native / custom-only props MUI would forward to the DOM <input>.
  textContentType: _textContentType,
  inputMode: _inputMode,
  borderRadius: _borderRadius,
  borderStyle: _borderStyle,
  ...rest
}: XTextFieldProps) {
  const style = useModifiedStyleForWeb({
    backgroundColor: 'none',
    ...styleProp,
  });
  const inputStyle = useModifiedStyleForWeb(inputStyleProp);
  const inputMode = !isNil(keyboardType) ? mapKeyboardTypeToInputMode[keyboardType] : undefined;
  const RightIcon = rightIcon ? mapIconNameToIconComponent[rightIcon] : undefined;
  return (
    <TextField
      {...rest}
      onChange={(e) => onChangeText?.(e.target.value)}
      inputProps={{ inputMode, maxLength }}
      InputProps={{
        endAdornment: RightIcon ? <RightIcon {...rightIconProps} /> : undefined,
        style: inputStyle,
      }}
      onKeyPress={(e) =>
        onKeyPress?.({
          nativeEvent: {
            // eslint-disable-next-line typescript/consistent-type-assertions -- FIXME: This rule was recently enabled for the repo
            key: e.key as KeyValue,
          },
        })
      }
      style={style}
    />
  );
}
